import { render, staticRenderFns } from "./NotesDeleteModal.vue?vue&type=template&id=28f74e10&scoped=true"
import script from "./NotesDeleteModal.vue?vue&type=script&lang=js"
export * from "./NotesDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./NotesDeleteModal.vue?vue&type=style&index=0&id=28f74e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f74e10",
  null
  
)

export default component.exports